var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"push-top-xl push-bottom-xl"},[_vm._l((_vm.features()),function(feature,i){return _c('SubscriptionCardFeatureListItem',{key:i,attrs:{"text":feature}})}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }